import { logoutAction } from '../../../../core/redux/actions/logout-action';
import store from '../../../../core/redux/store';
import { LpBackendError, lpRequest, refId } from '../../../../core/utils/lp-backend';
import { readWebhooks } from '../../../developer/data/datasources/read-webhooks';
import { readConfigFields } from '../../../settings/data/datasources/settings-fields';

/**
 * `GET /client/user/me` in cb's `/me` shape: the user's profile with the client as `organization`. Webhooks come
 * from the developer routes, which need admin; without it the page shows the defaults. `allow_custom_payment_fields`
 * comes from `GET /client/:cid/config/fields`.
 */
export const getMe = async (): Promise<any> => {
  let me: any;
  try {
    me = await lpRequest('GET', '/client/user/me');
  } catch (err) {
    // Any answer from the server logs the user out, as before; an unreachable server (status 0) does not.
    if (!(err instanceof LpBackendError) || err.status !== 0) {
      store.dispatch(logoutAction());
    }
    throw err;
  }

  const [webhooks, config] = await Promise.all([
    readWebhooks()
      .then((result) => result.webhooks)
      .catch(() => ({})),
    readConfigFields().catch(() => ({}))
  ]);
  const account = me.account || {};
  const integration_flow = account.integration_flow && {
    ...account.integration_flow,
    contract: refId(account.integration_flow.contract)
  };

  return {
    ...me.user,
    organization: {
      id: account.id,
      name: account.name,
      logo: account.logo,
      client_type: account.client_type,
      alerts: account.alerts || [],
      integration_flow,
      webhooks,
      flightboard_enabled: account.settings?.flightboard?.enabled || false,
      allow_custom_payment_fields: config.allow_custom_payment_fields || false
    }
  };
};
